import cookies from 'js-cookie';
import { COOKIE_PREFERENCES_DIDOMI_CONSENT } from 'Components/widgets/cookie-warning/constants';
import { isLocaleToDisplayDidomi } from 'Utils/locale/localeUtils';
export const hasAcceptedCookies = () => {
  const didomiCookieValue = cookies.get(COOKIE_PREFERENCES_DIDOMI_CONSENT);
  return !!didomiCookieValue && didomiCookieValue.includes('c:ga-');
};

const isAnalyticsEnabled = (): boolean => {
  return !isLocaleToDisplayDidomi() || hasAcceptedCookies();
};

export { isAnalyticsEnabled };
